import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    return (
        <footer>
            <div className="container-wide">
                <div className="footer-grid">
                    <div className="footer-column">
                        <h3>Services</h3>
                        <div className="footer-services">
                            <Link to="/services/seo" className="service-tag">SEO</Link>
                            <Link to="/services/paid-ads/google-ads" className="service-tag">Google Ads</Link>
                            <Link to="/services/paid-ads" className="service-tag">Social Media</Link>
                            <Link to="/services/web-development" className="service-tag">Web Design</Link>
                            <Link to="/services/web-development" className="service-tag">Web Development</Link>
                            <Link to="/services/email-marketing" className="service-tag">Email Marketing</Link>
                            <Link to="/services/gohighlevel" className="service-tag">GoHighLevel</Link>
                            <Link to="/services/gohighlevel" className="service-tag">Analytics</Link>
                        </div>
                    </div>

                    <div className="footer-column">
                        <h3>Company</h3>
                        <ul className="footer-links">
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/case-studies">Case Studies</Link></li>
                            <li><Link to="/services">Our Services</Link></li>
                            <li><Link to="/contact">Contact Us</Link></li>
                        </ul>
                    </div>

                    <div className="footer-column">
                        <h3>Industries</h3>
                        <ul className="footer-links">
                            <li><Link to="/industries/healthcare">Healthcare</Link></li>
                            <li><Link to="/industries/real-estate">Real Estate</Link></li>
                            <li><Link to="/industries/saas">SaaS</Link></li>
                            <li><Link to="/industries">All Industries</Link></li>
                        </ul>
                    </div>

                    <div className="footer-contact">
                        <h3>Contact Info</h3>
                        <a href="tel:+923004817173">+92 300 4817173</a>
                        <a href="mailto:ali@diginetworkads.com" style={{ fontSize: '18px', marginTop: '10px', display: 'block' }}>ali@diginetworkads.com</a>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="footer-bottom-left">
                        <p>&copy; 2026 Digi Network. All rights reserved.</p>
                        <div className="footer-legal">
                            <Link to="/privacy">Privacy Policy</Link>
                            <span className="separator">|</span>
                            <Link to="/terms">Terms of Service</Link>
                        </div>
                    </div>
                    <div className="social-links">
                        <a href="https://www.linkedin.com/company/digi-network/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                        <a href="https://web.facebook.com/DiginetworkFB" target="_blank" rel="noopener noreferrer">Facebook</a>
                        <a href="https://www.instagram.com/thediginetwork/" target="_blank" rel="noopener noreferrer">Instagram</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
